import { createSlice } from "@reduxjs/toolkit";

export const ASSIGNMENT_TAB = Object.freeze({
  TEAM_MEMBER: "AssignToTeamMember",
  B2B: "AssignToB2B",
  CONTRACT: "AssignToOrganization",
});

const initialState = {
  activeTab: ASSIGNMENT_TAB.TEAM_MEMBER,
  list: [],
  loading: false,
  error: null,
};

const assignmentMethodSlice = createSlice({
  name: "activityAssignmentMethod",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
      state.list = [];
      state.error = null;
    },
    fetchTeamMembersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchB2bListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchContractListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAssignmentListSuccess: (state, action) => {
      state.loading = false;
      state.list = action.payload;
    },
    fetchAssignmentListError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAssignmentMethod: () => initialState,
  },
});

export const {
  setActiveTab,
  fetchTeamMembersRequest,
  fetchB2bListRequest,
  fetchContractListRequest,
  fetchAssignmentListSuccess,
  fetchAssignmentListError,
  clearAssignmentMethod,
} = assignmentMethodSlice.actions;

export default assignmentMethodSlice.reducer;